export default "__VITE_ASSET__BmHO8tCX__"